<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="5">
          <BatchRunList/>
        </v-col>
        <v-col cols="7">
          <BatchRunWeekList/>
        </v-col>
      </v-row>
      <v-snackbar
          v-model="snack_flag"
          :timeout="5000"
          color="snack_color"
          dark
      >
        {{snack_text}}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import BatchRunList from "@/components/BatchRun/BatchRunList";
import BatchRunWeekList from "@/components/BatchRun/BatchRunWeekList";
import Sortable from "sortablejs";

export default {
  name: 'BatchRunWeek',
  props: {
    'subheight': {type: [Number], default: 200},
  },

  components: {
    BatchRunList,
    BatchRunWeekList
  },

  computed: {
    ...mapGetters('BatchRun', ['getColumns']),
    ...mapFields('BatchRun', ['options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm', 'isAlive']),
    ...mapFields('BatchRunWeek', ['snack_color', 'snack_text', 'snack_flag']),
  },

  methods: {
    ...mapActions('BatchRun', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems']),
    onResize() {
      this.windowHeight = (window.innerHeight - this.subheight) + 'px'
    },
    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm')
      this.options.page = 1
      this.fetchItemList()
    }, 800),

    updateOptions() {
      // console.log('updateOptions')
      this.fetchItemList()
    },

    onNotion(item) {
      // console.log('onNotion', item)
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
    onSyncNotion() {
      // console.log('onSyncNotion')
      this.fetchSyncNotionSelectedItems();
    },
    onRestore() {
      // console.log('onRestore')
      this.fetchRestoreSelectedItems();
    },
    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },
  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize)
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      windowHeight: (window.innerHeight - this.subheight) + 'px',
    }
  }
}
</script>

<style scoped lang="scss">
</style>
